/* tokens-sha256: 46db9ab428f1e57407b430d7179e0d4f10bfaf06991325f45ef5035eb48a65d5 — gen_tokens.py 생성물. 손으로 고치지 말고 design/tokens.json 을 고친 뒤 재생성 */
/* 테마: <html data-theme="light|dark"> 가 우선, 없으면 시스템 설정(prefers-color-scheme) */

:root {
  color-scheme: light;
  --color-primary: #002060;
  --color-on-primary: #FFFFFF;
  --color-primary-container: #E8F0FB;
  --color-on-primary-container: #002060;
  --color-accent: #0050A8;
  --color-on-accent: #FFFFFF;
  --color-brand-sky: #0088D8;
  --color-bg: #FFFFFF;
  --color-surface: #FFFFFF;
  --color-surface-alt: #F5F7FA;
  --color-text: #151A26;
  --color-text-muted: #5B6475;
  --color-border: #E6E9EF;
  --color-border-strong: #8A93A5;
  --color-danger: #C92A2A;
  --color-warning: #B85C00;
  --color-success: #23793A;
  --color-status-plan: #0050A8;
  --color-status-done: #23793A;
  --color-status-partial: #B85C00;
  --color-status-noshow: #C92A2A;
  --color-late: #C2410C;
  --color-scrim: #0B0F1A99;
  --font-family: Pretendard, -apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', system-ui, sans-serif;
  --font-numeric: tabular-nums;
  --font-weight-regular: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-weight-extrabold: 800;
  --text-display-size: 32px;
  --text-display-line: 40px;
  --text-display-weight: 800;
  --text-headline-size: 24px;
  --text-headline-line: 32px;
  --text-headline-weight: 700;
  --text-title-size: 20px;
  --text-title-line: 28px;
  --text-title-weight: 700;
  --text-section-size: 17px;
  --text-section-line: 24px;
  --text-section-weight: 700;
  --text-body-size: 15px;
  --text-body-line: 22px;
  --text-body-weight: 400;
  --text-body-strong-size: 15px;
  --text-body-strong-line: 22px;
  --text-body-strong-weight: 600;
  --text-label-size: 13px;
  --text-label-line: 18px;
  --text-label-weight: 500;
  --text-caption-size: 12px;
  --text-caption-line: 16px;
  --text-caption-weight: 500;
  --text-stat-size: 30px;
  --text-stat-line: 36px;
  --text-stat-weight: 800;
  --space-xxs: 2px;
  --space-xs: 4px;
  --space-sm: 8px;
  --space-md: 12px;
  --space-lg: 16px;
  --space-xl: 24px;
  --space-xxl: 32px;
  --space-xxxl: 48px;
  --space-gutter-compact: 16px;
  --space-gutter-wide: 24px;
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;
  --radius-pill: 999px;
  --elevation-level0: none;
  --elevation-level1: 0 1px 2px rgba(16,24,40,.06);
  --elevation-level2: 0 2px 8px rgba(16,24,40,.08);
  --elevation-level3: 0 8px 24px rgba(16,24,40,.12);
  --size-touch-min: 44px;
  --size-touch-min-android: 48px;
  --size-rail-width: 88px;
  --size-sidebar-width: 232px;
  --size-top-bar: 64px;
  --size-bottom-bar: 72px;
  --size-content-max: 1600px;
  --size-readable-max: 720px;
  --size-dot: 10px;
  --size-card-accent: 4px;
  --size-border: 1px;
  --bp-compact: 0;
  --bp-medium: 600px;
  --bp-expanded: 840px;
  --bp-large: 1200px;
  --motion-duration-fast: 120ms;
  --motion-duration-normal: 200ms;
  --motion-duration-slow: 320ms;
  --motion-easing-standard: cubic-bezier(0.2, 0, 0, 1);
  --motion-easing-decelerate: cubic-bezier(0, 0, 0, 1);
  --motion-easing-accelerate: cubic-bezier(0.3, 0, 1, 1);
}

[data-theme="dark"] {
  color-scheme: dark;
  --color-primary: #5B9CF5;
  --color-on-primary: #0B0B0B;
  --color-primary-container: #263042;
  --color-on-primary-container: #D6E4FF;
  --color-accent: #8AB8FF;
  --color-on-accent: #0B0B0B;
  --color-brand-sky: #4DB3F0;
  --color-bg: #111111;
  --color-surface: #181818;
  --color-surface-alt: #212121;
  --color-text: #EDEDED;
  --color-text-muted: #A0A0A0;
  --color-border: #2B2B2B;
  --color-border-strong: #6E6E6E;
  --color-danger: #FF8787;
  --color-warning: #FFA94D;
  --color-success: #69DB7C;
  --color-status-plan: #5B9CF5;
  --color-status-done: #69DB7C;
  --color-status-partial: #FFA94D;
  --color-status-noshow: #FF8787;
  --color-late: #FF922B;
  --color-scrim: #000000B3;
}

@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) {
    color-scheme: dark;
    --color-primary: #5B9CF5;
    --color-on-primary: #0B0B0B;
    --color-primary-container: #263042;
    --color-on-primary-container: #D6E4FF;
    --color-accent: #8AB8FF;
    --color-on-accent: #0B0B0B;
    --color-brand-sky: #4DB3F0;
    --color-bg: #111111;
    --color-surface: #181818;
    --color-surface-alt: #212121;
    --color-text: #EDEDED;
    --color-text-muted: #A0A0A0;
    --color-border: #2B2B2B;
    --color-border-strong: #6E6E6E;
    --color-danger: #FF8787;
    --color-warning: #FFA94D;
    --color-success: #69DB7C;
    --color-status-plan: #5B9CF5;
    --color-status-done: #69DB7C;
    --color-status-partial: #FFA94D;
    --color-status-noshow: #FF8787;
    --color-late: #FF922B;
    --color-scrim: #000000B3;
  }
}

/* 폭 구간(참고 — CSS 변수는 미디어쿼리에 못 쓰므로 값을 그대로 적는다)
   compact <600 · medium 600–839 · expanded 840–1199 · large ≥1200 */
